export default __webpack_public_path__ + "static/media/simulator.c02b1ba7.jpg";